import { DOCUMENT_TYPES } from "../constants";
import _Model from "./_Model";

export default class DocumentationDisplaySelector extends _Model {
  constructor(json) {
    super(json);
    this.showDatasheets = DocumentationDisplaySelector.getOrDefault(json, 'showDatasheets', true);
    this.showCADs = DocumentationDisplaySelector.getOrDefault(json, 'showCADs', true);
    this.showInstructionSheets = DocumentationDisplaySelector.getOrDefault(json, 'showInstructionSheets', true);
    this.showUserGuides = DocumentationDisplaySelector.getOrDefault(json, 'showUserGuides', true);
    this.showCertificates = DocumentationDisplaySelector.getOrDefault(json, 'showCertificates', true);
    this.showCatalogs = DocumentationDisplaySelector.getOrDefault(json, 'showCatalogs', true);
  }

  shouldDisplayKey = (key) => {
    const map = {
      [DOCUMENT_TYPES.PRODUCT_DATASHEET]: () => this.showDatasheets == null || this.showDatasheets,
      [DOCUMENT_TYPES.CAD]: () => this.showCADs == null || this.showDatasheets,
      [DOCUMENT_TYPES.INSTRUCTION_SHEET]: () => this.showInstructionSheets == null || this.showInstructionSheets,
      [DOCUMENT_TYPES.USER_GUIDE]: () => this.showUserGuides == null || this.showUserGuides,
      [DOCUMENT_TYPES.CERTIFICATE]: () => this.showCertificates  == null || this.showCertificates,
      [DOCUMENT_TYPES.CATALOG]: () => this.showCatalogs == null || this.showCatalogs,
    }
    return (map[key] ? map[key]() : false);
  }
}
